import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { MaintenanceMixture, MaintenanceMixtureDraft } from '../../../recommendations/types';
import { useForBindingId } from '../../../forBinding';
import api from '../../http';
import { toApiError } from '../utils';

export interface UpdateMixturePayload extends MaintenanceMixtureDraft {
	planId: string;
	mixtureId: string;
}

export function useUpdateAdviceMixture() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation<{ mixtures: MaintenanceMixture[] }, Error, UpdateMixturePayload>({
		mutationFn: async (payload) => {
			try {
				const { data } = await api.put<{ mixtures: MaintenanceMixture[] }>(
					'/advices/fertilization-plan/mixtures/update',
					payload,
					{ params: { forBinding } }
				);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao salvar a mistura');
			}
		},
		onSettled: (_data, _error, variables) =>
			queryClient.invalidateQueries({ queryKey: ['maintenance', variables.planId] }),
	});
}
